import React from 'react';
import { ButtonProps } from 'antd/lib/button';
import CcCluster from '../../../services/models/CcCluster';
import { CmonJobInstanceCommand } from '../../../services/cmon/models/CmonJobInstance';
import ButtonWithForm from '../../../common/General/ButtonWithForm';
import ClusterDeleteForm from './ClusterDeleteForm';
import JobActionButton from '../../Jobs/JobActionButton';

export default ClusterDeleteButton;

export type ClusterDeleteButtonProps = ButtonProps & {
    cluster: CcCluster;
    children?: React.ReactNode;
    onSuccess?: () => void;
};

function ClusterDeleteButton({
    cluster,
    children,
    onSuccess,
    ...rest
}: ClusterDeleteButtonProps) {
    return (
        <ButtonWithForm
            button={
                <JobActionButton
                    command={CmonJobInstanceCommand.REMOVE_CLUSTER}
                    clusterId={cluster.clusterId}
                    critical={true}
                    {...rest}
                >
                    {children || 'Remove cluster'}
                </JobActionButton>
            }
            form={<ClusterDeleteForm cluster={cluster} onSuccess={onSuccess} />}
        />
    );
}
